<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmGroup"
      :title="'CADASTRO DE METAS'"
      :showClearButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
    >
      <div class="d-flex flex-row align-items-center">
        <NxSelectFuncionario
          ref="nxSelectFuncionario"
          class="col-md-3 pl-0"
          :multiple="false"
          :variable="employeeTypes.RESPONSAVEL"
          :initialValue="editingManager ? editingManager : null"
          @update:value="handleSelectUpdate('gerenteId', $event)"
        />
        <NxSelectPeriodicidade
          ref="nxSelectPeriodicidade"
          class="col-md-3 pl-0"
          :initialValue="
            this.editingManagerPeriodicity !== null &&
            this.editingManagerPeriodicity !== undefined
              ? editingManagerPeriodicity
              : null
          "
          :value="form.periodicity"
          @update:value="handleSelectUpdate('periodicity', $event)"
        />
        <NxSelectReferenciaPeriodo
          ref="nxSelectReferenciaPeriodo"
          class="col-md-3 pl-0"
          :tipo="form.periodicity"
          :value="form.referencePeriod"
          @update:value="handleSelectUpdate('referencePeriod', $event)"
        />
        <DefaultButton
          class="col-md-3 p-0"
          :onClick="openModalAddProduto"
          btnVariant="btn-third"
          icon="fas fa-plus"
          text="NOVO produto"
        />
      </div>
      <FilterKpi
        ref="FilterKpi"
        :gerenteId="this.editingManager"
      />
      <Tables
        ref="tableGrid"
        :columns="[
          'PRODUTO',
          'TIPO',
          'TRAVA',
          'PESO',
          'META',
          'STATUS',
          'AÇÕES'
        ]"
        :showNew="true"
        v-on:New="openModalAddProduto"
        v-on:Load="onLoadByManager"
        v-on:Reload="onLoadByManager"
      >
        <tr
          v-for="obj in this.objList"
          v-bind:key="obj.id"
        >
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="formatBooleanToInt(!obj.inactive)"
            :value="obj.produto && obj.produto.nome ? obj.produto.nome : 'N/D'"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="formatBooleanToInt(!obj.inactive)"
            :value="obj && obj.tipo >= 0 ? getGoalTypeText(obj.tipo) : 'N/D'"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="formatBooleanToInt(!obj.inactive)"
            :value="obj && obj.trava >= 0 ? `${obj.trava}%` : 'N/D'"
            :class="
              formatBooleanToInt(!obj.inactive) ? 'text-danger' : 'text-success'
            "
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="formatBooleanToInt(!obj.inactive)"
            :value="obj && obj.peso >= 0 ? obj.peso.toString() : 'N/D'"
            :class="
              formatBooleanToInt(!obj.inactive) ? 'text-danger' : 'text-success'
            "
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="formatBooleanToInt(!obj.inactive)"
            :value="obj && obj.valorMeta ? formatMetaText(obj) : 'N/D'"
            :class="
              formatBooleanToInt(!obj.inactive) ? 'text-danger' : 'text-success'
            "
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="formatBooleanToInt(!obj.inactive)"
            :value="obj.inactive ? 'Inativa' : 'Ativa'"
            :class="obj.inactive ? 'text-danger' : 'text-success'"
          />
          <td class="row d-flex justify-content-center">
            <template>
              <div v-if="obj.inactive">
                <b-dropdown
                  variant="link"
                  size="sm"
                  no-caret
                >
                  <template slot="button-content">
                    <i
                      class="fa fa-check cursor-pointer"
                      style="color: black"
                      :title="$lang.Goals.AtiveGoalToolTip"
                    ></i>
                  </template>
                  <b-dropdown-header>
                    <strong>{{ $lang.Goals.ConfirmActiveGoal }}</strong>
                  </b-dropdown-header>
                  <b-dropdown-item
                    href="javascript:void(0);"
                    v-on:click="changeGoalStatus(obj, 'false')"
                    >{{ $lang.Common.Yes }}</b-dropdown-item
                  >
                  <b-dropdown-item href="javascript:void(0);">{{
                    $lang.Common.No
                  }}</b-dropdown-item>
                </b-dropdown>
              </div>
              <div v-else>
                <b-dropdown
                  variant="link"
                  size="sm"
                  no-caret
                >
                  <template slot="button-content">
                    <i
                      class="fas fa-ban text-third cursor-pointer"
                      style="color: red"
                      :title="$lang.Goals.InativeGoalToolTip"
                    ></i>
                  </template>
                  <b-dropdown-header>
                    <strong>{{ $lang.Goals.ConfirmInativeGoal }}</strong>
                  </b-dropdown-header>
                  <b-dropdown-item
                    href="javascript:void(0);"
                    v-on:click="changeGoalStatus(obj, 'true')"
                    >{{ $lang.Common.Yes }}</b-dropdown-item
                  >
                  <b-dropdown-item href="javascript:void(0);">{{
                    $lang.Common.No
                  }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </td>
        </tr>
      </Tables>
    </Forms>
    <ModalAddProduto
      v-if="isModalAddProdutoOpen"
      :gerenteId="form.gerenteId"
      :periodicity="form.periodicity"
      :referencePeriod="form.referencePeriod"
      :productEditing="productToEdit"
      @Close="closeModalAddProduto"
      @Reload="closeModalAddProduto(true)"
    />
  </div>
</template>

<script>
import {
  NxSelectFuncionario,
  NxSelectPeriodicidade,
  NxSelectReferenciaPeriodo
} from '@/components/nexum/components/custom-selects/index.js'
import Tools from '@/components/tools/Tools.js'
import { advancedOnException } from '@/components/tools/Utils'
import DefaultButton from '@/components/UI/button/defaultButton.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import {
  ListGoalMetricTypes,
  ListGoalPeriods,
  ListGoalTypes
} from '@/enums/enumGoalMetricTypes.js'
import MetasRepository from '@/shared/http/repositories/metas/metas.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import ModalAddProduto from './ModalAddProduto.vue'

import FilterKpi from '@/views/private/configurations/parametros/metas-gerente/components/FilterKpi.vue'

export default {
  name: 'MetasAdd',
  mixins: [ActionsForm],
  components: {
    FilterKpi,
    NxSelectFuncionario,
    NxSelectPeriodicidade,
    NxSelectReferenciaPeriodo,
    DefaultButton,
    ModalAddProduto
  },
  props: [
    'editingManager',
    'editingManagerPeriodicity',
    'editingManagerReferencePeriod'
  ],
  data () {
    return {
      data: null,
      productToEdit: null,
      form: {
        gerenteId: null,
        periodicity: null,
        referencePeriod: null
      },
      selectedManagerId: null,
      isModalAddProdutoOpen: false,
      employeeTypes: employeeTypes,
      listGoalTypes: ListGoalTypes,
      listGoalPeriods: ListGoalPeriods,
      listGoalMetricTypes: ListGoalMetricTypes
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onClear () {
      this.$root.$emit('clearForm')
      this.objList = []
    },
    onLoadByManager () {
      if (this.form.gerenteId) {
        MetasRepository.GetByUserId(
          this.form.gerenteId,
          this.$refs.tableGrid.pagingIndex,
          this.$refs.tableGrid.pagingLimit
        )
          .then((response) => {
            this.onResultGrid(response)
            if (
              this.editingManagerPeriodicity !== null &&
              this.editingManagerPeriodicity !== undefined
            ) { this.form.periodicity = this.editingManagerPeriodicity }
            if (
              this.editingManagerReferencePeriod !== null &&
              this.editingManagerReferencePeriod !== undefined
            ) { this.form.referencePeriod = this.editingManagerReferencePeriod }
          })
          .catch((err) => {
            console.error(err)
            loading.pop()
            toast.error(
              'Houve um erro ao carregar as metas para o gerente selecionado',
              'PRODUTOS'
            )
          })
      }
    },
    changeGoalStatus (obj, status) {
      loading.push()
      let data = {
        inactive: status
      }
      MetasRepository.ChangeStatusProduct(obj.id, data)
        .then(() => {
          this.onLoadByManager()
          loading.pop()
        })
        .catch((e) => advancedOnException(e, this.$lang))
        .finally(() => {
          if (this.$refs.FilterKpi) {
            this.$refs.FilterKpi.loadKpi()
          }
        })
    },
    onEdit (obj) {
      this.productToEdit = obj
      this.openModalAddProduto()
    },
    openModalAddProduto () {
      if (!this.form.gerenteId) {
        toast.warning(
          'É necessário selecionar o gerente antes de adicionar um novo produto',
          'PRODUTOS'
        )
        this.focusNxSelectFuncionario()
      } else if (
        this.form.periodicity === null ||
        this.form.periodicity === undefined
      ) {
        toast.warning(
          'É necessário selecionar a periodicidade antes de adicionar um novo produto',
          'PRODUTOS'
        )
        this.focusNxSelectPeriodicidade()
      } else {
        this.isModalAddProdutoOpen = true
      }
    },
    closeModalAddProduto (refresh = false) {
      if (refresh) this.onLoadByManager()
      this.isModalAddProdutoOpen = false
      this.productToEdit = null
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.form[fieldName] = selectedValue
        return
      }
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue)
          ? selectedValue.map((v) => (v.hasOwnProperty('value') ? v.value : v))
          : selectedValue.hasOwnProperty('value')
            ? selectedValue.value
            : selectedValue
      } else {
        this.clearField(fieldName)
      }
    },
    clearField (field) {
      if (field !== null) this.form[field] = null
    },
    getGoalTypeText (value) {
      let list = this.listGoalTypes

      const goalTypeText = Object.keys(list).find((key) => list[key] === value)
      return goalTypeText || 'N/D'
    },
    formatMetaText (obj) {
      let valorMeta = obj.valorMeta
      let metaText = valorMeta

      let list = this.listGoalMetricTypes
      let tipoMeta = obj.tipoMeta

      if (tipoMeta === list.QUANTITY) {
        metaText = `${valorMeta} Un`
      } else if (tipoMeta === list.AMOUNT) {
        metaText = Tools.formatMoneyBR(valorMeta)
      } else if (tipoMeta === list.PERCENTAGE) {
        metaText = `${valorMeta}%`
      } else {
        metaText = 'N/D'
      }

      return metaText
    },
    formatBooleanToInt (value) {
      if (value === true) return 1
      else return 0
    },
    focusNxSelectFuncionario () {
      this.$nextTick(() => {
        const selectFuncionario = this.$refs.nxSelectFuncionario
        if (selectFuncionario) {
          if (selectFuncionario.focus) {
            selectFuncionario.focus()
          } else {
            const inputElement = selectFuncionario.$el.querySelector('input')
            if (inputElement) {
              inputElement.focus()
            }
          }
        }
      })
    },
    focusNxSelectPeriodicidade () {
      this.$nextTick(() => {
        const selectPeriodicidade = this.$refs.nxSelectPeriodicidade
        if (selectPeriodicidade) {
          if (selectPeriodicidade.focus) {
            selectPeriodicidade.focus()
          } else {
            const inputElement = selectPeriodicidade.$el.querySelector('input')
            if (inputElement) {
              inputElement.focus()
            }
          }
        }
      })
    },
    changePeriodicity () {
      this.form.referencePeriod = null
    },
    changeReferencePeriod (id, periodicidade, value) {
      if (
        this.editingManagerPeriodicity === undefined ||
        this.editingManagerReferencePeriod === null ||
        this.editingManagerPeriodicity === null ||
        id === null ||
        periodicidade === null ||
        value === null
      ) { return }
      loading.push()
      let data = {
        periodicidade: periodicidade,
        referenciaPeriodo: value
      }
      MetasRepository.ChangePeriodicity(id, data)
        .then(() => {
          loading.pop()
        })
        .catch((e) => advancedOnException(e, this.$lang))
    }
  },
  watch: {
    'form.gerenteId': function (newValue, oldValue) {
      this.onLoadByManager()
    },
    'form.periodicity': function (newValue, oldValue) {
      this.changePeriodicity()
    },
    'form.referencePeriod': function (newValue, oldValue) {
      this.changeReferencePeriod(
        this.form.gerenteId,
        this.form.periodicity,
        newValue
      )
    },
    objList: {
      handler (newValue, oldValue) {
        if (newValue.length !== oldValue.length) {
          if (this.$refs.FilterKpi) {
            this.$refs.FilterKpi.loadKpi()
          }
        }
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/metas-gerente/add/MetasAdd.vue